import { FC } from 'react';
import { useRouter } from 'next/router';
import { Text } from '@mofid-securities/uikit';
import { getNextApiUrl } from '@/utils/next-api';
import BottomSheet from '@/components/BottomSheet';
import Button, { IButtonProps } from '@/components/Button';
import { classnames } from '@/utils/classnames';

interface ICompleteSejamNoticeBottomSheetProps {
  text: string;
  redirectUrl?: string;
  primaryButtonProps?: IButtonProps;
  secondaryButtonProps?: IButtonProps;
}

const CompleteSejamNoticeBottomSheet: FC<
  ICompleteSejamNoticeBottomSheetProps
> = ({ text, redirectUrl, primaryButtonProps, secondaryButtonProps }) => {
  const { replace } = useRouter();

  const redirectUrlQuery = redirectUrl ? `?redirectUrl=${redirectUrl}` : '';

  const handleCompleteSejam = () => {
    replace(getNextApiUrl(`auth/complete-register${redirectUrlQuery}`));
  };

  return (
    <div className="flex flex-col gap-y-8">
      <Text color="gray-110" size="sm" weight="regular">
        {text}
      </Text>
      <div className="flex gap-x-4">
        <Button
          className={classnames('w-2/3', primaryButtonProps?.className)}
          onClick={handleCompleteSejam}
        >
          {primaryButtonProps?.children || 'تکمیل سجام'}
        </Button>
        <Button
          className={classnames('w-1/3', secondaryButtonProps?.className)}
          variant={secondaryButtonProps?.variant || 'link'}
          onClick={BottomSheet.close}
        >
          بازگشت
        </Button>
      </div>
    </div>
  );
};

export const openCompleteSejamNoticeBottomSheet = (
  completeSejamNoticeBottomSheetProps: ICompleteSejamNoticeBottomSheetProps
) => {
  return BottomSheet.open({
    children: (
      <CompleteSejamNoticeBottomSheet
        {...completeSejamNoticeBottomSheetProps}
      />
    ),
  });
};
